import React from 'react'

import PortalModal from "./PortalModal"
import Backend from "../../utils/Backend";
import Navigation from "../../utils/Navigation";
import General from "../../utils/General";
import Event from "../../utils/Event";

const DEFAULT_PAGE = {
  is_live: true,
  add_to_menu: true,
}

export default class PagesModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      show: props.show,
      website: window.CURRENT_WEBSITE,
      pages: []
    }
  }

  componentDidMount(){
    this._refresh()
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      }, () => this._refresh())
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
  }

  _refresh() {
    this._getPages()
  }

  _getPages(){
    Backend.getPages().then(pages => {
      this.setState({pages})
    })
  }

  render() {
    let {
      show,
      pages,
      website
    } = this.state

    const staticPages = [
      {
        id: General.uuid(),
        title: "Cart Page",
        static: true,
        slug: website.cart_page_slug || "shop/cart",
        key: "cart_page_slug"
      },
      {
        id: General.uuid(),
        title: "Product Page",
        static: true,
        slug: website.product_page_slug || "shop/product",
        key: "product_page_slug"
      },
      {
        id: General.uuid(),
        title: "Collection Page",
        static: true,
        slug: website.collection_page_slug || "shop/collection",
        key: "collection_page_slug"
      }
    ]

    return (
      <>
        <PortalModal
          show={show}
          contentSuperContainerClassName="pages-modal main-container"
          showAsSideMenu={"false"}
          onHide={() => this.props.onHide()}
        >

          <div className="row">
            <div className='col'>
            <h3>Pages</h3>
            </div>
            <div className='col text-right'>
              <button
                className="btn btn--primary text-uppercase"
                onClick={() => this.props.onCreateEdit({...DEFAULT_PAGE})}
              >
                Add Page
              </button>
            </div>
          </div>

          <div className="row text-center justify-content-center">
            <div className="col-md-12">
              <table className="border--round table--alternate-row skip">
                <thead>
                  <tr>
                    <th className='text-left' width="100">Name</th>
                    <th width="100">Views</th>
                    <th className='text-right' width="100">Actions</th>
                  </tr>
                </thead>
                <tbody>
                {
                  pages.map((page, index) => (
                    <>
                      <tr>
                        <td className='text-left'>{page.title}</td>
                        <td>{page.views_no}</td>
                        <td className='text-right'>
                          <div className="btn-actions">
                            <button
                              onClick={() => {
                                window.open(Navigation.getUrl(`/${page.slug}`))
                              }}
                              title='View Page'
                            >
                              <span className="material-icons">open_in_new</span>
                            </button>
                            {!page.is_homepage && (
                              <>
                                <button
                                  onClick={() => this.props.onCreateEdit(page)}
                                  title='Edit Page'
                                >
                                  <span className="material-icons">edit_note</span>
                                </button>

                                <button
                                  onClick={() => this.props.onDelete(page)}
                                  title='Delete Page'
                                  className='t-danger'
                                >
                                  <span className="material-icons">clear</span>
                                </button>
                              </>
                            )}

                          </div>

                        </td>
                      </tr>
                    </>
                  ))
                }
                {
                  staticPages.map((page, index) => (
                    <>
                      <tr>
                        <td className='text-left'>{page.title}</td>
                        <td></td>
                        <td className='text-right'>
                          <div className="btn-actions">
                            <button
                              onClick={() => this.props.onCreateEdit(page)}
                              title='Edit Page'
                            >
                              <span className="material-icons">edit_note</span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                }
                </tbody>
              </table>
            </div>
          </div>
        </PortalModal>
      </>
    )
  }
}

PagesModal.defaultProps = {
  type: "photo",
  primaryColor: "#6c63ff"
}
